import React, {useEffect, useState} from "react";
import axios from "axios";
import {APIBASE} from "../../config/Pfalzmarkt.config";
import {useStore} from "../../store/store";
import DocumentRow from "./DocumentRow";
import {trimExt} from "../../service/general";

export default function Abrechnungen() {
    const [globalState, dispatch] = useStore();
    const [isLoggedIn, setIsLoggeIn] = useState(true);
    const [showTl, setShowTl] = useState(true);
    const [ showGs, setShowGs] = useState(true);
    const [isDownloaded, setIsDownloaded] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [error, setError] = useState(null);
    const header = "Authorization: Bearer " + localStorage.getItem("token");
    const erzeugerHeader = "Authorization: Bearer " + localStorage.getItem("tokenErzeuger");

    async function downloadDocument(documentName) {

        try {

            const response = await axios.get(
                APIBASE + 'api2/getTagesLs/' + trimExt(documentName),
                {headers: erzeugerHeader, responseType: 'arraybuffer'}
            );

            const data = await response.data;
            const bufferArray = new Uint8Array(data).buffer;
            const blob = new Blob([bufferArray], {
                type: "application/pdf", // Specify the MIME type of the file
            });

            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = documentName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (err) {
            console.log(err.message || 'Something went wrong!');
        }
    }

    function doLogin(event) {
        event.preventDefault();
        var formData = {
            username: event.target.elements.erzeuger.value,
            password: event.target.elements.password.value,
        };

        axios({
            method: 'post',
            url: APIBASE + 'api/pmExternalLogin',
            rejectUnauthorized: false,
            data: formData,
            headers: header
        }).then(result => {
            setIsLoggeIn(true);
            dispatch('IS_401_ERROR', false);
            localStorage.setItem('tokenErzeuger', result.data.token);
            dispatch('SET_AUTHTOKEN_ERZEUGER', localStorage.getItem('tokenErzeuger'));

        })
            .catch(error => {
                setIsLoggeIn(false);
                localStorage.removeItem('tokenErzeuger');
                dispatch('SET_AUTHTOKEN', null);
                console.log(error);
            });

    }


    const getAbrechnungen = async () => {

        try {
            axios.get(
                APIBASE + 'api2/tageslieferscheine', {headers: erzeugerHeader}
            ).then((response) => {
                setInvoices(response.data)
            })
                .catch(function (error) {
                    if (401 === error.response.status) {
                        dispatch('SET_AUTHTOKEN_ERZEUGER', null);
                    }
                })

        } catch (err) {
            console.log(err.message); // Todo: Errorhandling
        }
    }
    useEffect(() => {
        getAbrechnungen();
    }, [globalState.token, globalState.tokenErzeuger]);

    return <>{globalState.tokenErzeuger &&
        <div className="container-fluid">
            <div className="row">
                <div className="col-12"><p className="badge text-bg-success" onClick={() => {
                    setIsDownloaded(!isDownloaded)
                }}>{!isDownloaded ? " Nur ungelesene" : "alle"} Dokumente anzeigen </p>
                    <p className="badge text-bg-success m-2" onClick={() => {setShowGs(!showGs);setShowTl(true)}}>Nur Tageslieferscheine</p>
                    <p className="badge text-bg-success m-2" onClick={() => {setShowTl(!showTl);setShowGs(true)}}> Nur Gutschriften</p></div>
            </div>
            <div className="row">
                <table className="table">
                    <thead>
                    <tr>
                        <th scope="col">Dateiname</th>
                        <th scope="col">Datum der Dateierstellung</th>
                        <th scope="col">Zuletzt heruntergeladen am</th>
                    </tr>
                    </thead>
                    {showGs && <tbody id={"docGS"}>
                    <tr>
                        <td colSpan="3" align="center"><h3>Gutschriften</h3></td>
                    </tr>
                    {invoices && invoices.GS && invoices.GS.map((item, itemKey) => (
                            <DocumentRow key={itemKey} item={item} isDownloaded={isDownloaded} downloadDocument={downloadDocument}/>
                        )
                    )}
                    </tbody>}
                    {showTl && <tbody>
                    <tr>
                        <td colSpan="3" align="center"><h3>Tageslieferscheine</h3></td>
                    </tr>

                    {invoices && invoices.GS && invoices.tagesLS.map((item, itemKey) => (
                            <DocumentRow key={itemKey} item={item} isDownloaded={isDownloaded} downloadDocument={downloadDocument}/>
                        )
                    )}
                    </tbody>}
                </table>
            </div>
        </div>
    }
        {!globalState.tokenErzeuger &&
            <div className="d-flex flex-row bd-highlight mb-6 offset-3">
                <form onSubmit={doLogin}>
                    {error && error}
                    {false === isLoggedIn && <div className="alert alert-danger" role="alert">Ihr Login
                        hat leider nicht funktioniert. Bitte überprüfen Sie Benutzernamen und
                        Kennwort</div>}
                    <div className="col-12">
                        <p>Für den Abruf der Abrechnungen müssen Sie sich zusätzlich zu Ihrem bereits erfolgten
                            Login noch einmal authentifizieren. Wenn Sie für diesen Bereich
                            noch keine Zugangsdaten haben, wenden Sie sich bitte an Ihren Kundenbetreuer.</p>
                    </div>
                    <div className="col-6">
                        <label>
                            <p>Erzeuger</p>
                            <input id="erzeuger" name="erzeuger" type="text"/>
                        </label>
                    </div>
                    <div className="col-6">
                        <label>
                            <p>Passwort</p>
                            <input id="password" name="password" type="password"/>
                        </label>
                    </div>
                    <div className="col-3">
                        <button className="btn btn-success mt-3" type="submit">Anmelden</button>
                    </div>
                </form>
            </div>

        }
    </>
}